import React from 'react';
import { MapPin, CheckCircle2 } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const serviceAreas = [
  'Ballito Central',
  'Palm Lakes Estate',
  'Brettenwood Estate',
  'Zimbali Coastal Resort',
  'Simbithi Estate',
  'Salt Rock',
  'Sheffield Beach',
  'Ballito Bay',
  'Tinley Manor',
  "Thompson's Bay",
];

const ServiceAreaMap = () => {
  return (
    <section data-testid="service-area-section" className="py-20 bg-[#111640]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="inline-block bg-[#0066FF]/20 text-[#00D9FF] px-5 py-2 rounded-full text-sm font-bold uppercase tracking-wider mb-4">
            Service Coverage
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Proudly Serving Ballito & North Coast
          </h2>
          <p className="text-base md:text-lg text-gray-400 max-w-2xl mx-auto">
            Fast, reliable HVAC services across the greater Ballito area
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
          <Card className="bg-white/5 border border-white/10 shadow-xl overflow-hidden">
            <CardContent className="p-0">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d56893.74858871766!2d31.17747!3d-29.53807!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1ef70d0b54c2b273%3A0x3e5c65e29a4f5e8d!2sBallito%2C%20KwaZulu-Natal!5e0!3m2!1sen!2sza!4v1709654321000"
                width="100%"
                height="384"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Chill Point Service Area Map"
                className="w-full h-96"
              />
            </CardContent>
          </Card>

          <div>
            <h3 className="text-xl font-bold text-white mb-6">Areas We Service</h3>
            <div className="grid grid-cols-2 gap-3">
              {serviceAreas.map((area, i) => (
                <div key={i} className="flex items-start space-x-3">
                  <CheckCircle2 className="w-4 h-4 text-[#00D9FF] flex-shrink-0 mt-1" />
                  <span className="text-gray-300 text-sm font-medium">{area}</span>
                </div>
              ))}
            </div>

            <div className="mt-8 p-6 bg-gradient-to-br from-[#0066FF] to-[#00D9FF] rounded-xl text-white">
              <h4 className="text-lg font-bold mb-3">Don't See Your Area?</h4>
              <p className="mb-4 text-blue-100 text-sm">
                We also service surrounding North Coast areas. Call us to check if we cover your location!
              </p>
              <a
                href="tel:0644505026"
                className="inline-flex items-center space-x-2 bg-[#0A0E27] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#111640] transition-colors text-sm"
              >
                <MapPin className="w-4 h-4" />
                <span>Call: 064 450 5026</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreaMap;
